import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { lastValueFrom } from 'rxjs';
import { BaseApiService } from '../_base-http/base-api.service';
import { CommonConstant } from '../_constant/common.constant';
import { CategoryItem } from '../_models/category-item';
import {
  MENU_BAO_CAO_DINH_KY,
  MENU_CONG_BO_THONG_TIN,
  MENU_DAI_HOI_CO_DONG,
  MENU_HOI_DONG_DAU_TU,
  MENU_TAI_LIEU_CONG_TY,
} from '../_models/predefined-menu-list';
import { StateService } from './state.service';
@Injectable({
  providedIn: 'root',
})
export class CategoryService extends BaseApiService {
  categories: CategoryItem[] = [];
  currentLanguage = 'vi';

  constructor(
    @Optional() @Inject(REQUEST) private request: Request,
    private _http: HttpClient,
    private _stateService: StateService,
  ) {
    super(_http, _stateService);
    this.currentLanguage = this._stateService.currentLanguage$.getValue();
    this._stateService.currentLanguage$.subscribe({
      next: (l: string) => {
        this.currentLanguage = l;
      },
    });
  }

  getListAllByNavigationCode(query: { type?: string; navigationCode?: string }) {
    const params = this.applyQuery(query);
    return this.http.get<{
      totalCount: number;
      items: CategoryItem[];
    }>(`${this.baseApiUrl}category/get-list-all-by-navigation-code`, {
      params,
    });
  }

  async getListHierarchyByNavigationSlug(query: { type?: string; navigationSlug?: string }) {
    const params = this.applyQuery(query);
    const list = await this.http.get<{
      totalCount: number;
      items: CategoryItem[];
    }>(`${this.baseApiUrl}category/get-list-hierarchy-category-by-navigation-slug`, { params });

    return list;
  }

  getItemByLinkUrl(linkUrl: string) {
    const params = this.applyQuery({ linkUrl });
    return this.http.get<{
      totalCount: number;
      items: CategoryItem[];
    }>(`${this.baseApiUrl}category/get-category-by-linkurl`, { params });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getListAllPaging(query?: any) {
    const params = this.applyQuery(query);
    return this.http.get<{
      totalCount: number;
      items: CategoryItem[];
    }>(`${this.baseApiUrl}category/get-list-all-paging`, {
      params,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getListAllPagingParentCode(query?: any) {
    const params = this.applyQuery(query);
    return this.http.get<{
      totalCount: number;
      items: CategoryItem[];
    }>(`${this.baseApiUrl}category/get-list-category-by-parentcode-paging`, {
      params,
    });
  }

  getCatCongBoThongTin() {
    return this.categories.find((item: CategoryItem) => item.code === MENU_CONG_BO_THONG_TIN);
  }

  getCatBaoCaoDinhKy() {
    return this.categories.find((item: CategoryItem) => item.code === MENU_BAO_CAO_DINH_KY);
  }

  getCatDaiHoiCoDong() {
    return this.categories.find((item: CategoryItem) => item.code === MENU_DAI_HOI_CO_DONG);
  }

  getCatTaiLieuCongTy() {
    return this.categories.find((item: CategoryItem) => item.code === MENU_TAI_LIEU_CONG_TY);
  }

  async getAll(): Promise<CategoryItem[]> {
    if (this.request && this.request.body.redisCache) {
      if (!this.request.body.redisCache.isOpen) await this.request.body.redisCache.connect();
      const caching = await this.request.body.redisCache.get('API-All-Category-By-Language-' + this.currentLanguage);
      if (caching) {
        const cachingData = JSON.parse(caching);
        return cachingData;
      }
    }
    const query = {
      type: 'MENU',
      skipCount: CommonConstant.DEFAULT_SKIP_COUNT.toString(),
      MaxResultCount: CommonConstant.DEFAULT_MAX_RESULT_COUNT.toString(),
    };
    const params = this.applyQuery(query);
    const categories$ = this.http.get<{
      totalCount: number;
      items: CategoryItem[];
    }>(`${this.baseApiUrl}category/get-list-all-paging`, { params });
    const categories = (await lastValueFrom(categories$)).items;
    if (this.request && this.request.body.redisCache) {
      if (!this.request.body.redisCache.isOpen) await this.request.body.redisCache.connect();
      await this.request.body.redisCache.set('API-All-Category-By-Language-' + this.currentLanguage, JSON.stringify(categories));
      await this.request.body.redisCache.expire('API-All-Category-By-Language-' + this.currentLanguage, 18000);
    }
    this.categories = categories;
    this._stateService.categories$.next(categories);
    return categories;
  }

  getMenuHoiDongDauTu() {
    return this.categories.find((item: CategoryItem) => item.code === MENU_HOI_DONG_DAU_TU);
  }
}
